
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/villas/[id]",
      function () {
        return require("private-next-pages/villas/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/villas/[id]"])
      });
    }
  